import { getEmissionCategoryLogic } from "./EmissionCategory.logic";
import { saveListEmissionCategory } from "../Infrastructure/EmissionCategory.store";

export async function getEmissionCategory() {
  const emissions = await getEmissionCategoryLogic();

  saveListEmissionCategory(emissions);
}
